// extracted by mini-css-extract-plugin
export default {"container":"IKQd201sMM","message":"vEFlPSvhzw","error":"vhN9MGfy8U","icon":"TvYPJGaQys","value":"r1maVCiZIP"};